import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { SelectionCard } from 'components/SelectionCard/SelectionCard';
import styles from '../SelectSellingTypeStep.scss';
import { SellingType } from 'config/enums';
import { sellingTypeItemProps } from 'config/maps';
import { useAppStore } from 'stores/state';

export const SelectSellingTypeStepOptions: FC = () => {
  const { t } = useTranslation();

  const sellingTypes = useAppStore((state) => state.sellingTypes);
  const setSellingTypes = useAppStore((state) => state.setSellingTypes);

  const handleSelectSellingType = (sellingType: SellingType) => {
    if (sellingTypes.includes(sellingType)) {
      setSellingTypes(sellingTypes.filter((type) => type !== sellingType));
    } else {
      setSellingTypes([...sellingTypes, sellingType]);
    }
  };

  return (
    <div className={styles.selectSellingTypeStepOptions}>
      {Object.values(SellingType).map((sellingType) => {
        const Icon = sellingTypeItemProps[sellingType].icon;
        return (
          <SelectionCard
            description={t(`select-selling-type-step.options.item.description.${sellingType}`)}
            title={t(`select-selling-type-step.options.item.title.${sellingType}`)}
            onClick={() => handleSelectSellingType(sellingType)}
            isSelected={sellingTypes.includes(sellingType)}
            selectionType="multiple"
            key={sellingType}
            icon={<Icon />}
          />
        );
      })}
    </div>
  );
};
